
const RestrictedCountries = () => {
  return (
    <div className="flex flex-col gap-[8px] px-[24px] py-[24px] border-[1px] w-full border-[#d9d9d9] max-w-[750px] rounded-[20px]">
      <span className="text-[14px] leading-[18px] font-[400]">Belarus, Democratic Republic of the Congo, Côte d'Ivoire, Cuba, Islamic Republic of Iran, Iraq, Democratic People’s Republic of Korea, Liberia, Myanmar, Panama, Sudan, Syrian Arab Republic, Ukraine, United States of America, Bolivarian Republic of Venezuela, Zimbabwe</span>
    </div>
  )
}

export default RestrictedCountries
